/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../Styled/mixin";

import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";

import { StyledCompornent } from "./contents/c-style";
import Main from "./contents/Main";
import Recommend01 from "./contents/Recommend01";
import Recommend02 from "./contents/Recommend02";
// import Recommend03 from "./contents/Recommend03";

import Btn from "./part/Btn";

/* -------------------------

  component

---------------------------- */
function Result( props ) {
  const params = useParams();

  const dataResults = useSelector((state)=>state.resultDatas);

  let result;
  dataResults.map((d,i)=>(
    (d.pageName === params.childId)? result = d : ""
  ))

  return (
    <>
    <Helmet>
      <title>診断結果：{result.pageTitle} | 【公式】健康家族 通販サイト</title>
      <meta
          name="description"
          content={result.pageDiscription}
      />
      <meta name="keywords" content={result.pageKeyword} />
      <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0"></meta>
    </Helmet>

    <Styled className="p-result__contents isFadeInNormal">
    <div className="p-result__contents__inner">

      <Main
        flagName={result.flagName}
      ></Main>

      {/* 第１レコメンド */}
      {/*
        (result.recommend01)
        ?<Recommend01
          flagment={result.recommend01}
        ></Recommend01>
        :""
      */}

      {/* 第２レコメンド */}
      <Recommend02
        products={result.recommend02}
      ></Recommend02>

      {/*
      <Recommend03
        products={result.recommend03}
      ></Recommend03>
      */}
      <StyledOther className="p-result__sec_other">
        <div className="l-result__sec__inner l-inner--1100 l-inner--92">

          <div className="l-result__block">
            <div className="l-result__block__inner">

              <div className="l-result__box">
                <div className="l-result__box__inner">
                  <Btn
                    color_back={"#e3d8bb"}
                    color_font={"#451700"}
                    color_arrow={"#451700"}
                    href="/health/"
                  >こだわり健康補助食品一覧</Btn>
                </div>
              </div>

            </div>
          </div>

        </div>
      </StyledOther>

    </div>

    </Styled>

    </>
  );
}

export default Result;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  ${StyledCompornent}

.box{
  .txt{
    white-space: pre-wrap;
  }
}
	@media ${break_point_sp} {
	}
`;

const StyledOther = styled.section`
  padding: 60px 0;
  background: #ffffff;
  .l-result__block{
    .l-result__box{
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media ${break_point_sp} {

  }
`;
